
import React from 'react'
import Icon from 'react-icon-base'

const FaAngleLeft = props => (
    <Icon viewBox="0 0 40 40" {...props}>
        <g><path d="m26.5 12.1q0 0.3-0.2 0.6l-8.8 8.7 8.8 8.8q0.2 0.2 0.2 0.5t-0.2 0.5l-1.1 1.1q-0.3 0.3-0.6 0.3t-0.5-0.3l-10.4-10.4q-0.2-0.2-0.2-0.5t0.2-0.5l10.4-10.4q0.3-0.2 0.5-0.2t0.6 0.2l1.1 1.1q0.2 0.2 0.2 0.5z"/></g>
    </Icon>
)

export default FaAngleLeft



// WEBPACK FOOTER //
// ./~/react-icons/fa/angle-left.js